module.exports = __webpack_public_path__ + "src/assets/my.e84ad27d.png";